import currentRegion from "../lib/currentRegion";
import fetch from "../lib/fetch";
import renderComponents from "./renderComponents";

const PROMOS_URL = "/promos?regionCode=:regionCode";

/**
 * Fetches promos from the server, placing the list of candidate promos on the page.
 *
 * If the current region isn't available, we'll pass the `no-region` region to the server,
 * returning promos from the default region.
 *
 * @param {Object} context A custom context object added to placement engine's context.
 */
export default function renderPromos(context = {}) {
  currentRegion()
    .catch(() => "no-region")
    .then(regionCode => fetch(PROMOS_URL.replace(":regionCode", regionCode)))
    .then(data => data.json())
    .then(candidatePromos => renderComponents(candidatePromos, context));
}
